import { createContext, useContext, useEffect, useRef } from 'react'
import { clearProjectDataCache } from '../ProjectPlanSelect/hooks/useProjectPlanSelectData'
import { clearTeamDataCache } from '../TeamSelect/hooks/useTeamSelectData'

interface CacheContextValue {
  projectUuid: string
}

const CacheContext = createContext<CacheContextValue | null>(null)

export const useCacheContext = () => {
  const context = useContext(CacheContext)
  if (!context) {
    throw new Error('useCacheContext must be used within CacheProvider')
  }
  return context
}

interface CacheProviderProps {
  projectUuid: string
  children: React.ReactNode
}

export const CacheProvider = ({
  projectUuid,
  children,
}: CacheProviderProps) => {
  const prevProjectUuidRef = useRef<string>()

  useEffect(() => {
    if (
      prevProjectUuidRef.current &&
      prevProjectUuidRef.current !== projectUuid
    ) {
      clearProjectDataCache()
      clearTeamDataCache()
    }
    prevProjectUuidRef.current = projectUuid
  }, [projectUuid])

  useEffect(() => {
    return () => {
      clearProjectDataCache()
      clearTeamDataCache()
    }
  }, [])

  return (
    <CacheContext.Provider value={{ projectUuid }}>
      {children}
    </CacheContext.Provider>
  )
}
